/**
 * dev  : yunfeix
 * desc : 文章卡片
 */
<template>
  <section :style="`background-color: ${backgroundColor}`">
    <div :class="warpClass">
      <div class="story-item" @click="goDetail(item)" v-for="(item, index) in compProps.items" :key="index">
        <div class="card-img" :style="{'background-image': `url(${item.headImage ? item.headImage : defaultImage})`}">
          <div class="highlightsText" v-if="item.highlightsText" :style="{'color': compProps.privateProps.floatingLayerTextColor, 'background-color': compProps.privateProps.floatingLayerBgColor}">
            <span>{{item.highlightsText}}</span>
          </div>
        </div>
        <div class="card-content">
          <div class="card-text">
            <div class="pline">{{formatText(item)}}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const defaultImage = 'https://pic.tujia.com/upload/festatic/policy/toc-644-TQ-default-picture.png'
const defaultUserAvatarUrl = 'https://pic.tujia.com/upload/festatic/crn/chat_user_icon.png'
export default {
  name: '',
  props: {
    compId: {
      type: String,
      default: function() {
        return ''
      }
    },
    compProps: {
      type: Object,
      default: function() {
        return {
          mode: '0',
          items: [],
          totalCount: 0,
          privateProps: {}
        }
      }
    }
  },
  data() {
    return {
      defaultImage,
      defaultUserAvatarUrl
    }
  },
  computed: {
    backgroundColor() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.backgroundColor
      }
    },
    warpClass() {
      return 'double-col'
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    formatText(item) {
      let cardText = item?.title || ''
      if (!cardText) {
        cardText = item?.content?.trim() || ''
      }
      return String(cardText).replace(/<[^>]+>/g, '') // 去掉字符串中的所有html标签
    },
    goDetail(item) {
      this.$emit('action', { type: 'jumpArticleDetail', articleId: item.articleId })
    }
  },
  filters: {},
  components: {}
}
</script>

<style lang="scss" scoped>
@function size($n) {
  @return $n/375 * 100vw;
}
.double-col {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: size(12) size(12);
  .story-item {
    width: size(171);
    margin-bottom: size(10);
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    .card-img {
      width: 100%;
      height: size(170);
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      .highlightsText {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        color: #fff;
        font-size: size(12);
        padding: 8px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
      }
    }
    .status-img {
      height: size(18);
      left: 0;
      top: size(15);
      position: absolute;
    }
    .card-content {
      position: relative;
      background: #fff;
      padding: 10px 8px;
      .pline {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: size(14);
        line-height: size(18);
        color: #333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .line2 {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: size(14);
        line-height: size(18);
        color: #333;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .card-foot {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .foot-left {
          margin-right: 8px;
          display: flex;
          align-items: center;
          overflow: hidden;
          white-space: nowrap;
          /deep/ .tj-avatar__wrap--arc {
            width: size(20)!important;
            height: size(20)!important;
            img {
              width: 100%!important;
              height: 100%!important;
            }
          }
          .name {
            margin-left: 5px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: size(11);
            color: #666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .foot-right {
          .like {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            img {
              height: size(15);
              width: size(15);
            }
            .like-count {
              margin-left: 2px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              font-size: size(13);
              color: #666666;
            }
          }
        }
      }
    }
  }
  .default-img {
    height: 100%;
    width: 100%;
    background: #E6E8EB;
  }
}
</style>
